import React, { lazy, Suspense } from 'react';
import { Dialog, DialogContent, DialogTitle, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { LedgerOptions, CrdrExportOptions, ExportModalProps, PartyExportOptions, PaymentReceiptExportOptions } from '../types';
import { ExportPageSkeleton } from './ExportPageSkeleton';
import {
  creditExportColumns,
  customerExportColumns,
  DebitExportColumns,
  itemsExportColumns,
  LedgerColumns,
  LedgerSetoffColumns,
  paymentExportColumns,
  purchaseExportColumns,
  receiptExportColumns,
  supplierExportColumns,
} from '../data/exportData';
import { ItemExportPage } from '../pages/ItemExportPage';
// import { CreditDebitExportPage } from '../pages/CreditExportPage';

// Lazy load all export pages
const SalesExportPage = lazy(() => import('../pages/SalesExportPage').then((m) => ({ default: m.SalesExportPage })));
const LedgersPage = lazy(() => import('../pages/ledgersPage').then((m) => ({ default: m.LedgersPage })));
const PurchaseExportPage = lazy(() => import('../pages/PurchaseExportPage').then((m) => ({ default: m.PurchaseExportPage })));
const PosExportPage = lazy(() => import('../pages/PosExportPage').then((m) => ({ default: m.PosExportPage })));
const TdsExportPage = lazy(() => import('../pages/TdsExportPage').then((m) => ({ default: m.TdsExportPage })));
const TcsExportPage = lazy(() => import('../pages/TcsExportPage').then((m) => ({ default: m.TcsExportPage })));
const CreditDebitExportPage = lazy(() => import('../pages/CreditDebitExportPage').then((m) => ({ default: m.CreditDebitExportPage })));
const CustomerSupplierExportPage = lazy(() =>
  import('../pages/CustomerSupplierExportPage').then((m) => ({ default: m.CustomerSupplierExportPage }))
);
const PaymentReceiptExportPage = lazy(() =>
  import('../pages/PaymentReceiptExportPage').then((m) => ({ default: m.PaymentReceiptExportPage }))
);

export const ExportModal: React.FC<ExportModalProps> = ({ open, onClose, action, exportOptions, accounttypeflag }) => {
  if (!action) {
    return null;
  }
  console.log(accounttypeflag, 'accounttypeflag88888888');

  let title: string;

  const renderExportPage = () => {
    const commonProps = {
      onExit: onClose,
    };

    switch (action) {
      case 'SALESEXPORT':
        return (
          <SalesExportPage
            exportOptions={{
              selectedArray: exportOptions.selectedArray,
              startDate: exportOptions.startDate,
              endDate: exportOptions.endDate,
              filters: exportOptions.filters,
            }}
            {...commonProps}
            isModal={true}
          />
        );

      case 'LEDGERSEXPORT':
        return (
          <LedgersPage
            exportOptions={exportOptions.ledgerOptions as LedgerOptions}
            startDate={exportOptions.startDate ?? undefined}
            endDate={exportOptions.endDate ?? undefined}
            // @ts-ignore
            accounttypeflag={exportOptions.ledgerOptions.AccountDetails?.[0]?.setoff ?? undefined}
            // @ts-ignore
            columns={exportOptions.ledgerOptions.AccountDetails?.[0]?.setoff === true ? LedgerSetoffColumns : LedgerColumns}
            {...commonProps}
          />
        );

      case 'PURCHASEEXPORT':
        console.log(exportOptions, 'exportOptions');
        return (
          <PurchaseExportPage
            selectedArray={exportOptions.selectedArray}
            startDate={exportOptions.startDate ?? undefined}
            endDate={exportOptions.endDate ?? undefined}
            columns={purchaseExportColumns}
            {...commonProps}
          />
        );
      case 'ITEMSEXPORT':
        return (
          <ItemExportPage
            selectedArray={exportOptions.selectedArray}
            startDate={exportOptions.startDate ?? undefined}
            endDate={exportOptions.endDate ?? undefined}
            columns={itemsExportColumns}
            {...commonProps}
          />
        );
      case 'POSEXPORT':
        return (
          <PosExportPage
            exportOptions={{
              selectedArray: exportOptions.selectedArray,
              startDate: exportOptions.startDate,
              endDate: exportOptions.endDate,
              filters: exportOptions.filters,
            }}
            {...commonProps}
            isModal={true}
          />
        );

      case 'TDSEXPORT':
        return <TdsExportPage />;

      case 'TCSEXPORT':
        return <TcsExportPage />;

      case 'CRDREXPORT':
        return (
          <CreditDebitExportPage
            exportOptions={exportOptions.crDrOption as CrdrExportOptions}
            startDate={exportOptions.startDate ?? undefined}
            endDate={exportOptions.endDate ?? undefined}
            selectedArray={exportOptions.selectedArray}
            title={exportOptions.crDrOption?.noteType === 'CreditNote' ? 'Credit Note Export' : 'Debit Note Export'}
            columns={exportOptions.crDrOption?.noteType === 'CreditNote' ? creditExportColumns : DebitExportColumns}
            {...commonProps}
          />
        );
      case 'PAYMENTRECEIPTEXPORT':
        return (
          <PaymentReceiptExportPage
            exportOptions={exportOptions as PaymentReceiptExportOptions}
            startDate={exportOptions.startDate ?? undefined}
            endDate={exportOptions.endDate ?? undefined}
            title={exportOptions.crDrOption?.noteType === 'CreditNote' ? 'Credit Note Export' : 'Debit Note Export'}
            columns={exportOptions.transactionOption?.transactionType === 'Payment' ? paymentExportColumns : receiptExportColumns}
            // columns={exportOptions exportOptions?.transactionOption?.transactionType === 'Payment' ? paymentExportColumns : receiptExportColumns,}
            {...commonProps}
          />
        );
      case 'PARTYEXPORT':
        return (
          <CustomerSupplierExportPage
            exportOptions={exportOptions as PartyExportOptions}
            title={exportOptions.partyOption?.partyType === 'CUSTOMER' ? 'Customer Export' : 'Supplier Export'}
            columns={exportOptions.partyOption?.partyType === 'CUSTOMER' ? customerExportColumns : supplierExportColumns}
            startDate={exportOptions.startDate ?? undefined}
            endDate={exportOptions.endDate ?? undefined}
            {...commonProps}
          />
        );
      // } else {
      //   return <DebitExportPage exportOptions={exportOptions.crDrOption as CrdrExportOptions} {...commonProps} />;
      // }

      // default:
      //   return null;
    }
  };
  switch (action) {
    case 'SALESEXPORT':
      title = 'Sales Export';
      break;
    case 'LEDGERSEXPORT':
      title = 'Ledger Export';
      break;
    case 'PURCHASEEXPORT':
      title = 'Purchase Export';
      break;
    case 'POSEXPORT':
      title = 'POS Export';
      break;
    case 'TDSEXPORT':
      title = 'TDS Export';
      break;
    case 'TCSEXPORT':
      title = 'TCS Export';
      break;
    case 'ITEMSEXPORT':
      title = 'Item Export';
      break;
    case 'CRDREXPORT':
      title = exportOptions?.crDrOption?.noteType === 'CreditNote' ? 'Credit Note Export' : 'Debit Note Export';
      break;
    case 'PAYMENTRECEIPTEXPORT':
      title = exportOptions?.transactionOption?.transactionType === 'Payment' ? 'Payment Export' : 'Receipt Export';
      break;
    case 'PARTYEXPORT':
      title = exportOptions?.partyOption?.partyType === 'CUSTOMER' ? 'Customer Export' : 'Supplier Export';
      break;
    default:
      title = '';
  }
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      sx={{
        zIndex: 1300,
        '& .MuiBackdrop-root': {
          zIndex: 1299,
        },
        '& .rs-picker-popup': {
          zIndex: '9999 !important',
        },
        '& .rs-picker-menu': {
          zIndex: '9999 !important',
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 24px 48px rgba(0, 0, 0, 0.12)',
          maxHeight: '90vh',
          zIndex: 1300,
        },
      }}
    >
      <DialogTitle
        sx={{
          backgroundColor: 'primary.main',
          padding: '10px 15px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          m: 0,
        }}
      >
        <Typography
          sx={{
            color: '#fff',
            fontWeight: 500,
            fontSize: '1.1rem',
          }}
        >
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: '#fff',
            '&:hover': {
              backgroundColor: 'rgba(255, 255, 255, 0.1)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          p: 0,
          '&.MuiDialogContent-root': {
            paddingTop: 0,
            overflow: 'auto',
            maxHeight: 'calc(90vh - 64px)', // Subtract header height
          },
        }}
      >
        <Box sx={{ p: 3, minHeight: 'auto' }}>
          <Suspense fallback={<ExportPageSkeleton isModal={true} />}>{renderExportPage()}</Suspense>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

// Keep SalesExportModal for backward compatibility
export const SalesExportModal: React.FC<ExportModalProps> = (props) => {
  if (props.open) {
    return <ExportModal {...props} />;
  } else {
    return null;
  }
};

export default ExportModal;
